<template>
	<v-layout row wrap fill-height>
		<v-flex xs12>
			<iframe :src="iframeSource" frameborder="0" width="100%" height="100%" scrolling="no"></iframe>			
		</v-flex>
	</v-layout>
</template>

<script>
	export default{
		data(){
			return{
				ip:''
			}
		},

		computed:{
			iframeSource(){
				if(process.env.VUE_APP_SERVED == "online"){
					return "https://"+ this.ip
				} else {
					return "http://"+ this.ip
				}
			}

		},

		sockets:{

		stopScreen(){      	
			this.$router.push({name:'home', params: {license: this.$store.state.setting.license} })
			}
		},		

		created(){
			this.ip = this.$route.params.ip
		}

	}
</script>
      